import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6571049a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ariflex" }
const _hoisted_2 = { slot: "back" }
const _hoisted_3 = { class: "ui container segment very padded" }
const _hoisted_4 = { class: "ui form" }
const _hoisted_5 = { class: "mt-10 align-center field" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "text-center" }

import { computed, onMounted, ref } from "vue";
  import packageInfo from "@/../package.json";
  // import '../assets/styles/app.css';
  // import { useRouter, useRoute } from 'vue-router'
  import { useUserSessionStore } from '@/stores/userSession'
  import { toCamelCase, rules } from "@/plugins/common";
import { onBeforeRouteUpdate } from "vue-router";

  
export default /*#__PURE__*/_defineComponent({
  ...{
    name: "LoginView",
    components: {
    },
  },
  __name: 'Login',
  props: {
    email: String,
  },
  setup(__props) {

const props = __props;

// import { required, email, minLength } from "vuelidate/lib/validators";
// import Modal from "vue-semantic-modal";
  const store = useUserSessionStore();

  // const router = useRouter();
  // const route = useRoute();
  const show = false,
        isFullscreen = false,
        submitted = ref(false),
        userEmail = ref(""),
        userPassword = ref(""),
        showModal = {
          fullscreen: false,
        },
        confirmed = {
          fullscreen: true,
        },
        isLoading = ref(false),
        testButton = false;
  // snackbar
  const snackbar = ref(false),
        snackbarText = ref('Access rejected. Try again.'),
        snackbarPos = ref('top' as 'top'|'bottom'),
        snackbarType = ref('error' as 'error'|'warning'|'info'|'success'),
        snackbarIcon = computed(() => snackbarSetup[snackbarType.value].icon),
        snackbarTitle = computed(() => snackbarSetup[snackbarType.value].title),
        snackbarColor = computed(() => snackbarSetup[snackbarType.value].color),
        snackbarTimeout = ref(5000),
        snackbarSetup = {
          info: {
            color: "info",
            title: "Infomation",
            type: "info",
            icon: "mdi-information",
          },
          success: {
            color: "success",
            title: "Success",
            type: "success",
            icon: "mdi-check-circle",
          },
          warning: {
            color: "warning",
            title: "Warning",
            type: "warning",
            icon: "mdi-alert",
          },
          error: {
            color: "error",
            title: "Error",
            type: "error",
            icon: "mdi-alert-circle",
          }
        }
  let click: any = undefined,
      clicks = 1;

  const version = computed(() => packageInfo.version);


  
  
  
  function alertVersion() {
    alert(version.value);
  }
  
  const disableAutoComplete = () => {
    let elements = document.querySelectorAll('[autocomplete="off"]');
    if (!elements) return;
    elements.forEach((element) => {
      element.setAttribute("readonly", "readonly");
      element.addEventListener("focus", function () {
        setTimeout(() => {
          element.removeAttribute("readonly");
        }, 800);
      });
      element.addEventListener("blur", function () {
        setTimeout(() => {
          element.setAttribute("readonly", "readonly");
        }, 100);
      });
    });
  };

  const login = async function (event: any) {
    isLoading.value = true
    const results = await event
    isLoading.value = false

    submitted.value = true;
    const payload = {
      email: userEmail.value,
      password: userPassword.value,
    };
    const that = this;
    store
      .loginJWT(payload)
      .then((response: any) => {
        
        if (!response) {
          that.$router.push("/logout");
        } else {
          that.$router.push("/").catch((error: any) => {
            console.log(error);
          });
        }
      })
      .catch((error) => {
        snackbarType.value = 'error';
        snackbarText.value = error.msg || error.message || error.toString();
        snackbar.value = true;
      });
  };
  const clicked = () => {
    // let clicks = clicks
    return new Promise ((resolve) => {
      if (click) {
        //Double click or defined by clicks
        ++clicks
        if (clicks && clicks === 4) {
          clearTimeout(click)
          resolve(true)
        }
        
      }
      click = setTimeout(() => {
        //Single click
        click = undefined
        clicks = 1
        resolve(false)
      }, 500)
    })
  };

  onMounted(() => {
      disableAutoComplete();
  });

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_container, { style: {"min-height":"400px"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("form", {
                    ref: "form",
                    onSubmit: _withModifiers(login, ["prevent"])
                  }, [
                    _createVNode(_component_v_text_field, {
                      modelValue: userEmail.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userEmail).value = $event)),
                      name: "username",
                      label: "Email",
                      type: "text",
                      placeholder: "aaa@bbb.com",
                      required: "",
                      rules: [_unref(rules).required,_unref(rules).isEmail]
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: userPassword.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userPassword).value = $event)),
                      name: "password",
                      label: "Password",
                      type: "password",
                      placeholder: "password",
                      required: "",
                      rules: [_unref(rules).required,_unref(rules).minLength(4)]
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_btn, {
                      type: "submit",
                      loading: isLoading.value,
                      class: "mt-4",
                      block: "",
                      color: "primary",
                      value: "log in",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Login ")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ], 40, _hoisted_6)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "mt-5 offset-sm-4 text-center text-grey v-col-12 v-col-sm-4",
            onDblclick: alertVersion
          }, [
            _createElementVNode("small", null, "Version: " + _toDisplayString(version.value), 1)
          ], 32)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("template", null, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_snackbar, {
          modelValue: snackbar.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((snackbar).value = $event)),
          "auto-height": "",
          timeout: snackbarTimeout.value,
          color: snackbarColor.value,
          title: snackbarTitle.value,
          icon: snackbarIcon.value,
          top: snackbarPos.value === 'top',
          "multi-line": "",
          style: {}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              class: "pr-3",
              dark: "",
              large: "",
              icon: snackbarIcon.value
            }, null, 8, ["icon"]),
            _createTextVNode(" " + _toDisplayString(snackbarText.value) + " ", 1),
            (snackbarTimeout.value === 0)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (snackbar.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("clear")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "timeout", "color", "title", "icon", "top"])
      ])
    ])
  ], 64))
}
}

})